import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import SplitDirection from "terriajs-cesium/Source/Scene/SplitDirection";
import ViewerMode from "../../Models/ViewerMode";
import Box from "../../Styled/Box";
import Checkbox from "../../Styled/Checkbox/Checkbox";
import { TextSpan } from "../../Styled/Text";
import { RawButton } from "../../Styled/Button";
import { Spacing } from "../../Styled/Spacing";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sides = {
  left: "settingPanel.terrain.left",
  both: "settingPanel.terrain.both",
  right: "settingPanel.terrain.right"
};
const TerrainSide = observer(props => {
  var _terria$currentViewer;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const {
    terria
  } = props;
  const showTerrainOnSide = (side, event) => {
    if (event) {
      event.stopPropagation();
    }
    runInAction(() => {
      switch (side) {
        case sides.left:
          terria.terrainSplitDirection = SplitDirection.LEFT;
          terria.showSplitter = true;
          break;
        case sides.right:
          terria.terrainSplitDirection = SplitDirection.RIGHT;
          terria.showSplitter = true;
          break;
        case sides.both:
          terria.terrainSplitDirection = SplitDirection.NONE;
          break;
      }
      terria.currentViewer.notifyRepaintRequired();
    });
  };
  const toggleDepthTestAgainstTerrainEnabled = event => {
    event.stopPropagation();
    runInAction(() => {
      terria.depthTestAgainstTerrainEnabled = !terria.depthTestAgainstTerrainEnabled;
    });
    terria.currentViewer.notifyRepaintRequired();
  };
  const isCesiumWithTerrain = terria.mainViewer.viewerMode === ViewerMode.Cesium && terria.mainViewer.viewerOptions.useTerrain && ((_terria$currentViewer = terria.currentViewer) === null || _terria$currentViewer === void 0 || (_terria$currentViewer = _terria$currentViewer.scene) === null || _terria$currentViewer === void 0 ? void 0 : _terria$currentViewer.globe);
  const supportsDepthTestAgainstTerrain = isCesiumWithTerrain;
  const depthTestAgainstTerrainEnabled = supportsDepthTestAgainstTerrain && terria.depthTestAgainstTerrainEnabled;
  const depthTestAgainstTerrainLabel = depthTestAgainstTerrainEnabled ? t("settingPanel.terrain.showUndergroundFeatures") : t("settingPanel.terrain.hideUndergroundFeatures");
  let currentSide = sides.both;
  if (isCesiumWithTerrain) {
    switch (terria.terrainSplitDirection) {
      case SplitDirection.LEFT:
        currentSide = sides.left;
        break;
      case SplitDirection.RIGHT:
        currentSide = sides.right;
        break;
    }
  }
  if (!isCesiumWithTerrain) return null;
  return /*#__PURE__*/_jsxs(Box, {
    padded: true,
    column: true,
    fullWidth: true,
    children: [/*#__PURE__*/_jsx(TextSpan, {
      children: t("settingPanel.terrain.sideLabel")
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), /*#__PURE__*/_jsx(_StyledBox, {
      $_css: props.spaced && "gap: 6px;",
      children: Object.values(sides).map(side => /*#__PURE__*/_jsx(_StyledRawButton, _objectSpread(_objectSpread({
        onClick: evt => showTerrainOnSide(side, evt)
      }, props.buttonProps), {}, {
        $_css2: theme.overlay,
        $_css3: side === currentSide ? "rgba(255, 255, 255, 0.5)" : "transparent",
        $_css4: props.buttonProps && props.buttonProps.css,
        $_css5: props.activeColor && side === currentSide && "background-color: ".concat(props.activeColor),
        children: /*#__PURE__*/_jsx(TextSpan, {
          textLight: true,
          small: true,
          children: t(side)
        })
      }), side))
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), supportsDepthTestAgainstTerrain && /*#__PURE__*/_jsx(Checkbox, {
      id: "depthTestAgainstTerrain",
      isChecked: depthTestAgainstTerrainEnabled,
      title: depthTestAgainstTerrainLabel,
      onChange: toggleDepthTestAgainstTerrainEnabled,
      children: /*#__PURE__*/_jsx(TextSpan, {
        children: t("settingPanel.terrain.hideUnderground")
      })
    })]
  });
});
TerrainSide.defaultProps = {
  spaced: true
};
export default TerrainSide;
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", "\n          "])), p => p.$_css);
var _StyledRawButton = _styled2(RawButton).withConfig({
  displayName: "TerrainSide___StyledRawButton",
  componentId: "sc-1u25gfd-0"
})(["background:", ";padding:14px 0;display:flex;align-items:center;justify-content:center;width:100%;border:1px solid ", ";", " ", ""], p => p.$_css2, p => p.$_css3, p => p.$_css4, p => p.$_css5);